const ru = {
  "srv_general_unknown": "Что-то пошло не так. Попробуйте ещё раз.",
  "srv_general_network": "Ошибка сети. Проверьте подключение.",
  "srv_general_timeout": "Время ожидания запроса истекло. Попробуйте ещё раз.",
  "srv_general_not_found": "Не найдено",
  "srv_general_invalid_id": "Некорректный id",
  "srv_general_invalid_json": "Некорректный JSON",
  "srv_auth_admin_only": "Только для администратора",
  "srv_auth_owner_only": "Только для владельца",
  "srv_auth_unauthorized": "Нет доступа",
  "srv_auth_not_authenticated": "Не выполнен вход",
  "srv_auth_invalid_token": "Некорректный токен",
  "srv_auth_session_expired": "Нет токена обновления",
  "srv_auth_token_expired": "Срок действия токена истёк",
  "srv_auth_device_signed_out": "На этом устройстве выполнен выход",
  "srv_auth_invalid_login": "Неверное имя пользователя/email или пароль",
  "srv_auth_wrong_password": "Текущий пароль неверный",
  "srv_auth_email_already_exists": "Email уже зарегистрирован",
  "srv_auth_email_taken_other": "Этот email теперь используется другим аккаунтом",
  "srv_auth_same_email": "Это уже ваш email",
  "srv_auth_same_username": "Это уже ваше имя пользователя",
  "srv_auth_username_taken": "Имя пользователя уже занято",
  "srv_auth_username_invalid": "Имя пользователя должно содержать 3–20 букв, цифр или символов подчёркивания",
  "srv_auth_user_not_found": "Пользователь не найден",
  "srv_auth_password_mismatch": "Пароли не совпадают",
  "srv_auth_password_weak": "Новый пароль должен содержать не менее 8 символов, включая букву и цифру",
  "srv_auth_password_same": "Новый пароль должен отличаться от текущего",
  "srv_auth_rate_limited": "Слишком много попыток. Попробуйте позже.",
  "srv_auth_signup_rate_limited": "Слишком много регистраций из этой сети. Попробуйте позже.",
  "srv_auth_verify_link_invalid": "Некорректная или уже использованная ссылка подтверждения",
  "srv_auth_verify_link_expired": "Срок действия ссылки подтверждения истёк. Запросите новую.",
  "srv_auth_email_already_verified": "Email уже подтверждён.",
  "srv_auth_verification_sent": "Письмо с подтверждением отправлено.",
  "srv_auth_email_change_sent": "Ссылка подтверждения отправлена на новый email. Подтвердите её, чтобы завершить изменение.",
  "srv_auth_reset_link_invalid": "Некорректная или просроченная ссылка для сброса",
  "srv_auth_reset_sent": "Если аккаунт существует, ссылка для сброса отправлена.",
  "srv_auth_password_updated": "Пароль обновлён. Войдите с новым паролем.",
  "srv_auth_password_changed": "Пароль изменён. Войдите снова на других устройствах.",
  "srv_auth_signed_out_all": "Выполнен выход на всех устройствах",
  "srv_auth_signed_out_others": "Выполнен выход на всех других устройствах",
  "srv_auth_device_revoked": "На устройстве выполнен выход",
  "srv_subscription_required": "Эта функция доступна для Premium-пользователей",
  "srv_subscription_plan_unavailable": "Тестовый план недоступен.",
  "srv_subscription_order_not_found": "Заказ не найден",
  "srv_payment_provider_unreachable": "Не удалось связаться с платёжным провайдером. Попробуйте ещё раз.",
  "srv_payment_invoice_failed": "Платёжный провайдер не смог создать счёт. Попробуйте ещё раз.",
  "srv_payment_not_configured": "Криптоплатёжный шлюз ещё не настроен. Добавьте API-ключи NOWPayments.",
  "srv_payment_invalid_signature": "Некорректная подпись",
  "srv_exchange_connection_not_found": "Подключение не найдено",
  "srv_exchange_unsupported": "Биржа не поддерживается",
  "srv_exchange_unreachable": "Биржа недоступна с сервера",
  "srv_exchange_key_not_readonly": "Этот API-ключ имеет разрешения на торговлю/вывод. Создайте ключ только для чтения (отключите Trade и Withdraw).",
  "srv_exchange_verify_first": "Проверьте подключение перед включением реальной торговли",
  "srv_insufficient_balance": "Сумма превышает доступный баланс",
  "srv_trade_amount_positive": "Сумма должна быть больше 0",
  "srv_trade_invalid_withdrawal": "Некорректная сумма вывода",
  "srv_trade_bot_needs_tp_sl": "Для бота требуются Stop Loss и Take Profit",
  "srv_trade_no_position": "Нет открытой позиции для продажи",
  "srv_trade_position_not_found": "Позиция не найдена",
  "srv_trade_symbol_required": "Требуется символ",
  "srv_trade_invalid_symbol": "Некорректный символ",
  "srv_trade_invalid_interval": "Недопустимый интервал",
  "srv_trade_verify_email": "Подтвердите email перед открытием сделок.",
  "srv_trade_verify_email_auto": "Подтвердите email перед включением автоторговли.",
  "srv_trade_demo_min": "Минимальный демо-баланс — 100",
  "srv_trade_demo_max": "Демо-баланс слишком большой (макс. 10,000,000)",
  "srv_trade_leverage_confirm": "Кредитное плечо выше 20x требует двойного подтверждения",
  "srv_trade_high_risk_confirm": "Риск выше 15% требует подтверждения высокого риска",
  "srv_trade_high_liquidation_risk": "Высокий риск ликвидации",
  "srv_trade_no_fee": "Без комиссии (удержание 7+ дней).",
  "srv_insufficient_data": "Недостаточно данных свечей для этого бэктеста",
  "srv_notification_not_found": "Уведомление не найдено",
  "srv_nft_image_failed": "Не удалось сгенерировать изображение",
  "ntf_cloud_enabled": "Облачная торговля включена — бот работает 24/7.",
  "ntf_cloud_disabled": "Облачная торговля отключена.",
  "srv_trade_no_price": "Нет доступной цены для {symbol}",
  "srv_trade_risk_lock": "Ограничение риска: макс. {pct}% баланса на сделку",
  "srv_trade_max_leverage": "Макс. кредитное плечо для {symbol} — {max}x",
  "srv_trade_risk_range": "Риск для {symbol} должен быть от 1% до {max}%",
  "srv_payment_unsupported_currency": "Неподдерживаемая валюта. Выберите одну из: {list}",
  "srv_exchange_unsupported_named": "Неподдерживаемая биржа: {name}",
  "srv_auth_username_cooldown": "Имя пользователя можно изменить снова через {days} дн.",
  "srv_exchange_connection_error": "Ошибка подключения: {error}",
  "srv_trade_early_fee": "Применена комиссия за ранний вывод 5% ({fee}).",
  "ntf_risk_drawdown": "Макс. просадка {dd}% достигла лимита {limit}%. Все позиции закрыты. Бот остановлен.",
  "ntf_risk_losses": "{count} убыточных сделок подряд. Бот остановлен. Подтвердите для возобновления.",
  "ntf_cooldown": "Охлаждение после {count} убыточных сделок подряд — новые входы приостановлены на {minutes} мин.",
  "ntf_trade_opened": "Сделка открыта: {symbol} {timeframe} · оценка {score} · {leverage}",
  "ntf_nft_opened": "NFT позиция открыта (Демо): {name}",
  "ntf_nft_closed": "NFT позиция закрыта (Демо): P&L {pnl}",
  "ntf_trade_closed": "{reason}: {symbol} закрыта · P&L {pnl}",
  "ntf_opportunity": "⚠️ {symbol} · {timeframe} · {action} · Оценка {score}. Вход ${entry} / TP ${tp} / SL ${sl}. Только для информации — не финансовая рекомендация.",
  "app_name": "FIREBIRD AI",
  "tagline": "Торговля криптой и NFT с ИИ",
  "login": "Войти",
  "register": "Регистрация",
  "logout": "Выйти",
  "email": "Электронная почта",
  "password": "Пароль",
  "name": "Имя",
  "welcome_back": "С возвращением, трейдер",
  "create_account": "Создайте аккаунт",
  "no_account": "Ещё нет аккаунта?",
  "have_account": "Уже есть аккаунт?",
  "account_created": "Аккаунт создан — демо-счёт на $100 готов",
  "loading": "Загрузка…",
  "demo_mode": "Демо-режим",
  "demo_balance": "Демо-баланс",
  "nav_dashboard": "Панель управления",
  "nav_charts": "Графики в реальном времени",
  "nav_signals": "ИИ-сигналы",
  "nav_autotrade": "Авто-трейдинг",
  "nav_manual": "Ручная торговля",
  "nav_scanner": "Сканер мимкоинов",
  "nav_backtest": "Бэктест 5×5",
  "nav_positions": "Позиции и отчёты",
  "nav_nft": "Коллекция NFT",
  "nav_assistant": "ИИ-ассистент",
  "nav_settings": "Биржа и настройки",
  "nav_subscription": "Премиум-план",
  "subscription_subtitle": "Откройте премиальную торговую аналитику — оплачивайте криптой.",
  "current_plan": "Текущий план",
  "premium": "Премиум",
  "free_plan": "Бесплатный план",
  "renews_on": "Продлевается",
  "active": "Активен",
  "best_value": "Самое выгодное",
  "plan_monthly": "Ежемесячно",
  "plan_annual": "Ежегодно",
  "plan_test": "Тест",
  "days": "дн.",
  "pay_with_crypto": "Оплатить криптой",
  "opening_checkout": "Открываем оплату…",
  "gateway_not_ready": "Криптоплатёжный шлюз ещё не настроен. Оплата Premium станет доступна после добавления API-ключей NOWPayments.",
  "premium_only": "Только для Premium",
  "premium_gate_desc": "Эта функция входит в FireBird Premium. Перейдите на Premium, чтобы открыть все ИИ-сигналы, авто-трейдинг и сканер возможностей.",
  "go_premium": "Перейти на Premium",
  "billing_history": "История платежей",
  "no_invoices": "Счетов пока нет. Ваши криптоплатежи появятся здесь.",
  "date": "Дата",
  "plan_col": "План",
  "amount_col": "Сумма",
  "status_col": "Статус",
  "view_invoice": "Посмотреть счёт",
  "check_status": "Проверить статус платежа",
  "checking": "Проверка…",
  "payment_still_pending": "Платёж ещё не подтверждён. Мы будем проверять автоматически.",
  "status_paid": "Оплачено",
  "status_created": "В ожидании",
  "status_partially_paid": "Оплачено частично",
  "status_expired": "Истёк",
  "status_failed": "Не удалось",
  "status_refunded": "Возвращено",
  "status_cancelled": "Отменено",
  "status_canceled": "Отменено",
  "payment_processing": "Платёж обнаружен — активируем ваш Premium-план…",
  "payment_success": "Premium активирован. Добро пожаловать!",
  "payment_cancelled": "Платёж отменён.",
  "payment_error": "Не удалось начать оплату. Попробуйте ещё раз.",
  "popup_blocked": "Оплата готова. Если новая вкладка не открылась, воспользуйтесь ссылкой ниже.",
  "checkout_opened_hint": "Оплата открыта в новой вкладке. Не видите?",
  "open_checkout": "Открыть оплату",
  "pay_currency_label": "Оплатить через",
  "pay_currency_hint": "Мы принимаем USDC в сети Solana и BNB в сети BSC. Выбранный актив фиксируется при оплате.",
  "feat_signals": "Полные ИИ-сигналы (криптовалюты, шиткоины, NFT)",
  "feat_autotrade": "Авто-трейдинг с управлением рисками",
  "feat_scanner": "Сканер мимкоинов и возможностей",
  "feat_alerts": "Умные оповещения по электронной почте",
  "feat_priority": "Приоритетная доставка сигналов",
  "feat_save": "2 месяца бесплатно по сравнению с ежемесячной оплатой",
  "feat_test_quick": "Разовый тест на $1 — проверяет реальный процесс оплаты",
  "demo_account_settings": "Настройки демо-аккаунта",
  "demo_settings_desc": "Задайте свой демо-баланс и сбросьте учебный торговый аккаунт. Это затрагивает только демо-данные — подписку и реальную торговлю это не затронет.",
  "custom_demo_balance": "Произвольный демо-баланс (USDC)",
  "demo_min_hint": "По умолчанию 500 · минимум 100",
  "reset_demo_account": "Сбросить демо-аккаунт",
  "reset_demo_confirm_title": "Сбросить демо-аккаунт?",
  "reset_demo_confirm_desc": "Демо-баланс будет установлен на ${bal}, все демо-сделки и история P/L будут удалены, а статусы просадки, остановки и охлаждения — сброшены. Это нельзя отменить. Ваша подписка и реальные данные не пострадают.",
  "demo_reset_done": "Демо-аккаунт сброшен — баланс установлен на ${bal}",
  "demo_min_balance_error": "Минимальный демо-баланс — 100",
  "nav_guide": "Руководство для начинающих",
  "owner_console": "Консоль владельца",
  "total_value": "Общая стоимость",
  "cash": "Наличные",
  "holdings": "Активы",
  "unrealized_pnl": "Нереализованный PnL",
  "top_signals": "Лучшие ИИ-сигналы",
  "market_overview": "Обзор рынка",
  "whale_activity": "Киты и «умные деньги»",
  "market_pulse": "Пульс рынка",
  "news_up": "{name} вырос на {pct}% за 24 ч",
  "news_down": "{name} упал на {pct}% за 24 ч",
  "kind_cex": "CEX",
  "kind_iranian_cex": "Иранская CEX",
  "kind_dex": "DEX",
  "price": "Цена",
  "change_24h": "24 ч",
  "score": "Оценка",
  "action": "Действие",
  "buy": "Покупка",
  "sell": "Продажа",
  "hold": "Держать",
  "timeframe": "Таймфрейм",
  "symbol": "Символ",
  "amount_usd": "Сумма (USD)",
  "open_position": "Открыть позицию",
  "close": "Закрыть",
  "no_positions": "Нет открытых позиций",
  "entry": "Вход",
  "current": "Текущая",
  "exit": "Выход",
  "reason": "Причина",
  "pnl": "PnL",
  "win_rate": "Процент побед",
  "total_trades": "Всего сделок",
  "total_pnl": "Общий PnL",
  "wl": "П / У",
  "open_label": "Открыта",
  "run_backtest": "Запустить бэктест",
  "running": "Выполняется…",
  "bt_subtitle": "Стратегия протестирована на 5 исторических окнах для каждого таймфрейма.",
  "window_results": "Результаты по окнам",
  "window": "Окно",
  "trades": "Сделки",
  "return_label": "Доходность",
  "max_drawdown": "Макс. просадка",
  "auto_trade_on": "Авто-трейдинг активен",
  "auto_trade_off": "Авто-трейдинг выключен",
  "enable_autotrade": "Включить авто-трейдинг (демо)",
  "reset_demo": "Сбросить демо ($100)",
  "activity_log": "Журнал активности",
  "waiting_signals": "Ожидание сигналов…",
  "enable_to_start": "Включите авто-трейдинг, чтобы начать",
  "reauthorize_bot": "Переавторизовать бота",
  "leverage": "Кредитное плечо",
  "high_leverage_warning": "Высокое плечо — вы можете потерять всю маржу (ликвидация).",
  "bot_description": "Бот сканирует все монеты на 15m / 1h / 4h, входит по лучшему сигналу (соотношение прибыль/риск 2:1, стоп обязателен) и сопровождает позиции скользящим тейк-профитом в демо-режиме.",
  "rule_rr": "Прибыль:Риск 2:1 (стоп обязателен)",
  "rule_max_concurrent": "Макс. 2 одновременных авто-сделки",
  "rule_leverage": "Авто-плечо ≤ 10x · Вручную ≤ 50x",
  "rule_circuit": "Аварийный предохранитель при просадке 20%",
  "rule_halt": "Остановка после 5 убытков",
  "rule_scan": "Сканирует все монеты и таймфреймы",
  "rule_entry": "Оценка входа ≥ {score} на {tfs}",
  "rule_cooldown": "Охлаждение {min} мин после {losses} убытков",
  "risk_status": "Статус риска",
  "risk_mode_active": "Активен",
  "risk_mode_halted": "Остановлен",
  "consecutive_losses_label": "Убытков подряд",
  "drawdown_label": "Просадка",
  "open_positions_label": "Открытые позиции",
  "max_concurrent_reached": "Достигнуто максимума одновременных сделок.",
  "bot_reauthorized": "Бот повторно авторизован. Вы можете снова включить авто-трейдинг.",
  "cloud_trading": "Облачный трейдинг",
  "enable_cloud": "Включить облачный трейдинг",
  "disable_cloud": "Отключить облачный трейдинг",
  "cloud_status": "Статус облака",
  "cloud_on": "Работает 24/7",
  "cloud_off": "Выключено",
  "cloud_desc": "Бот работает на наших серверах 24/7, даже когда ваше устройство выключено.",
  "notifications": "Уведомления",
  "no_notifications": "Уведомлений пока нет",
  "mark_all_read": "Отметить всё прочитанным",
  "connect_exchange": "Подключить биржу",
  "api_key": "API-ключ",
  "api_secret": "API-секрет",
  "api_key_optional": "API-ключ (необязателен для общедоступных цен)",
  "connect": "Подключить",
  "test": "Проверить",
  "remove": "Удалить",
  "verified": "Проверено",
  "not_verified": "Не проверено",
  "connected_exchanges": "Подключённые биржи",
  "aggregated_balances": "Балансы · Все биржи",
  "aggregated_prices": "Цены в реальном времени · Все биржи",
  "no_connections": "Биржи пока не подключены.",
  "connect_wallet": "Подключить кошелёк",
  "wallet_connected": "Кошелёк подключён",
  "wallet_note": "Некастодиальный — мы никогда не храним ваши приватные ключи.",
  "wallet_security": "Кошелёк и безопасность",
  "wallet_never_ask": "Мы никогда не запрашиваем ваш приватный ключ или сид-фразу.",
  "disconnect_wallet": "Отключить кошелёк",
  "switch_chain": "Сменить сеть",
  "native_balance": "Баланс нативного токена",
  "wallet_chain": "Сеть",
  "dex_onchain": "DEX (on-chain)",
  "sign_in_wallet": "Войти через кошелёк",
  "waiting_signature": "Ожидание подписи кошелька…",
  "dex_demo_note": "Вы подписываете своим кошельком — ключи никогда не покидают ваше устройство.",
  "view_on_explorer": "Посмотреть в эксплорере",
  "wallet_required_dex": "Подключите кошелёк, чтобы торговать on-chain.",
  "tx_pending": "Транзакция в ожидании…",
  "tx_confirmed": "Транзакция подтверждена",
  "tx_failed": "Транзакция не удалась",
  "connected_label": "Подключено",
  "not_connected_label": "Не подключено",
  "copy_address": "Скопировать адрес",
  "readonly_warning": "Создайте API-ключ с правами ТОЛЬКО НА ЧТЕНИЕ. Отключите вывод и торговлю.",
  "cex_security_notice": "Мы НИКОГДА не храним ваши приватные ключи и не запрашиваем права на вывод средств.",
  "api_passphrase_optional": "Парольная фраза (необязательно)",
  "read_only_label": "Только чтение",
  "how_to_create_key": "Как создать ключ только для чтения",
  "connected_wallets": "Подключённые кошельки",
  "no_wallet_connected": "Кошелёк не подключён.",
  "no_exchange_linked": "Биржа не привязана.",
  "smart_contract_allowances": "Разрешения смарт-контрактов",
  "no_allowances": "Нет активных разрешений.",
  "revoke": "Отозвать",
  "max_spend": "Макс. трата",
  "link_readonly_hint": "Используйте панель «Подключить биржу», чтобы привязать ключ только для чтения.",
  "vpn_notice": "Для пользователей из некоторых регионов этот маркетплейс может требовать VPN.",
  "ir_friendly": "Подходит для Ирана",
  "best_price": "Лучшая цена",
  "marketplace_listings": "Объявления маркетплейса",
  "tab_opps": "Возможности",
  "opportunities": "Возможности",
  "high_opportunity": "Высокая возможность",
  "alerts_triggered_today": "оповещений сегодня",
  "score_range": "Диапазон оценок",
  "timeframe_label": "Таймфрейм",
  "direction_label": "Направление",
  "risk_disclaimer_title": "Предупреждение о рисках",
  "risk_disclaimer": "Сигналы носят только информационный характер. Это НЕ финансовая рекомендация. 98% шиткоинов проваливаются. Всегда используйте стоп-лосс. Никогда не рискуйте более 1–5% в одной сделке.",
  "no_opportunities": "Сейчас возможностей нет. Сканер запускается каждые 5 минут.",
  "alerts_title": "Оповещения",
  "enable_scanner": "Включить авто-сканер",
  "min_score_label": "Минимальная оценка",
  "monitor_timeframes": "Таймфреймы для мониторинга",
  "max_alerts_day": "Макс. оповещений в день",
  "notify_method_label": "Способ уведомления",
  "notify_in_app": "Только в приложении",
  "notify_in_app_email": "В приложении + по почте",
  "alert_history_title": "История оповещений",
  "no_alert_history": "Оповещений пока нет.",
  "nft_markets": "NFT-маркетплейсы",
  "iran_friendly": "Подходит для Ирана",
  "key_security_note": "Ключи шифруются на сервере и никогда не хранятся в вашем браузере.",
  "exchange": "Биржа",
  "no_balances": "Нет балансов (добавьте API-ключи, чтобы загрузить актуальные балансы).",
  "safety": "Безопасность",
  "opportunity": "Возможность",
  "holders": "Холдеры",
  "verdict": "Вердикт",
  "coin": "Монета",
  "chain": "Сеть",
  "scanning": "Сканирование…",
  "scanner_subtitle": "Отобранные мимкоины с пригодной для торговли ликвидностью (оценка ≥ 75). Неизвестные и мошеннические токены не показываются.",
  "safety_note": "Безопасность = блокировка ликвидности + отказ от минта + распределение холдеров (ориентировочно, не финансовая рекомендация).",
  "ask_ai": "Спросите Firebird AI...",
  "send": "Отправить",
  "chat": "Чат",
  "ai_empty": "Спросите о монете, таймфрейме или стратегии. Ничто здесь не является финансовой рекомендацией.",
  "ai_thinking": "Firebird AI думает…",
  "ai_error": "Извините, сейчас я не мог ответить.",
  "score_coin": "Оценить эту монету",
  "any_coin_symbol": "Любой символ монеты",
  "analyzing": "Анализ…",
  "entry_strategy": "Вход",
  "exit_strategy": "Выход",
  "risk": "Риск",
  "signals_subtitle": "ИИ + техническая оценка по всем монетам",
  "momentum": "Импульс",
  "simulated_feed": "симулированная лента",
  "collection": "Коллекция Firebird 555",
  "nft_subtitle": "Firebird / Феникс — 555 предметов · 6 легендарных редкостей · у каждой своя история разрушения и возрождения",
  "rares": "Легендарные редкости",
  "floor_price": "Флорная цена",
  "minted": "Минтировано",
  "total_supply": "Общее предложение",
  "rarity": "Редкость",
  "bt_download": "Скачать",
  "bt_stop_loss": "Стоп-лосс (TP = 2× SL)",
  "bt_min_score": "Мин. оценка сигнала",
  "bt_share": "Поделиться",
  "bt_history": "Сохранённые запуски бэктеста",
  "bt_card_saved": "Карточка результата скачана",
  "bt_compare_tf": "Сравнить таймфреймы",
  "bt_best": "ЛУЧШИЙ",
  "bt_worst": "ХУДШИЙ",
  "bt_run_all": "Запустить все монеты",
  "bt_by_section": "Результаты по разделам",
  "bt_per_coin": "Результаты по монетам",
  "bt_avg_return": "Средняя доходность",
  "bt_skipped": "Пропущено (недостаточно данных)",
  "bt_sec_major": "Основные",
  "bt_sec_shitcoin": "Шиткоины",
  "bt_sec_meme": "Мемы",
  "bt_sec_nft": "NFT токены",
  "bt_sec_other": "Прочее",
  "bt_data_live": "РЫНОЧНЫЕ данные",
  "bt_data_simulated": "СИМУЛИРОВАННЫЕ данные (рыночные данные недоступны)",
  "risk_per_trade": "Риск на сделку",
  "max_amount": "Макс.",
  "tier_major": "Крупные",
  "tier_mid": "Средняя капитализация",
  "tier_meme": "Мем/Памп",
  "high_risk_ack": "Я понимаю, что это сделка с Высоким риском (более 15% моего баланса).",
  "lev_warn_yellow": "Высокий риск ликвидации",
  "lev_warn_red": "Экстремальное плечо — очень высокий риск ликвидации. Требуется двойное подтверждение.",
  "lev_ack": "Я понимаю, что могу потерять всю маржу.",
  "lev_confirm_again": "Экстремальное плечо: нажмите ещё раз для подтверждения.",
  "confirm_again": "Подтвердить снова",
  "high_risk_required": "Пожалуйста, отметьте подтверждение высокого риска.",
  "lev_ack_required": "Пожалуйста, подтвердите предупреждение об экстремальном плече.",
  "trait_element": "Элемент",
  "trait_aura": "Аура",
  "trait_background": "Фон",
  "prev": "Назад",
  "next": "Далее",
  "all": "Все",
  "save": "Сохранить",
  "risk_lock": "Блокировка риска",
  "max_position": "Макс. позиция %",
  "trailing_stop": "Трейлинг-стоп %",
  "take_profit": "Тейк-профит %",
  "stop_loss": "Стоп-лосс %",
  "risk_strategy": "Риск и стратегия",
  "exchanges": "Подключения к биржам",
  "connected": "Подключено",
  "disconnected": "Не подключено",
  "withdraw_demo_wallet": "Вывод (демо-кошелёк)",
  "withdraw_fee_note": "При выводе средств ранее чем через 7 дней после последнего депозита взимается комиссия 5% за досрочный вывод (доля владельца).",
  "withdraw": "Вывести",
  "trade_history": "История сделок",
  "no_closed_trades": "Закрытых сделок пока нет",
  "owner_subtitle": "Доходность всех пользователей (только просмотр) · журнал комиссий (2% с каждой прибыльной сделки, еженедельный расчёт · 5% за досрочный вывод)",
  "total_users": "Всего пользователей",
  "total_commission": "Общая комиссия",
  "this_week": "В этой неделе",
  "total_volume": "Общий объём",
  "all_time": "за всё время",
  "settles_weekly": "расчёт раз в неделю",
  "commission_breakdown": "Разбивка комиссий",
  "from_trade_profits": "Из прибыли от сделок (2%)",
  "from_withdrawal_fees": "Из комиссий за досрочный вывод (5%)",
  "owner_rate": "Ставка владельца",
  "settlement": "Расчёт",
  "early_exit_fee": "Комиссия за досрочный выход",
  "weekly": "Еженедельно",
  "daily_accrual": "Ежедневное начисление",
  "no_commission_yet": "Комиссий пока нет — они накапливаются с прибыльных сделок.",
  "users_performance": "Доходность пользователей (только просмотр)",
  "col_user": "Пользователь",
  "col_role": "Роль",
  "col_joined": "Дата регистрации",
  "col_volume": "Объём",
  "col_balance": "Баланс",
  "role_owner": "владелец",
  "role_user": "пользователь",
  "guide_intro": "Добро пожаловать в Firebird AI Trade. Следуйте этим шагам, чтобы безопасно начать.",
  "guide_step": "Шаг",
  "guide1_title": "Демо-режим включён",
  "guide1_desc": "Вы начинаете с демо-баланса $100. Реальные деньги не используются, пока вы явно не включите реальную торговлю с вашими собственными безопасными ключами.",
  "guide2_title": "Просмотрите панель управления",
  "guide2_desc": "Стоимость портфеля, лучшие ИИ-сигналы, обзор рынка, активность китов и пульс рынка — всё в одном месте.",
  "guide3_title": "Проверьте ИИ-сигналы",
  "guide3_desc": "Монеты оцениваются от 0 до 100 на основе RSI, пересечений SMA и импульса на разных таймфреймах.",
  "guide4_title": "Спросите ИИ-ассистента",
  "guide4_desc": "Получите оценку монеты со стратегией входа/выхода и заметками о рисках от Firebird AI Core (GPT-5.6).",
  "guide5_title": "Попробуйте авто-трейдинг (демо)",
  "guide5_desc": "Пусть бот открывает позиции на покупку по сильным сигналам и сопровождает их трейлинг-стопом / тейк-профитом.",
  "guide6_title": "Сканируйте мимкоины",
  "guide6_desc": "Показываются только мимкоины, пригодные для торговли, с высокой оценкой безопасности — без неизвестных или мошеннических токенов.",
  "guide7_title": "Исследуйте NFT Firebird 555",
  "guide7_desc": "Просмотрите коллекцию из 555 фениксов с 6 легендарными редкостями.",
  "disclaimer": "Демо/песочница. Ничто здесь не является финансовой рекомендацией. Никакая система не может гарантировать будущий процент побед.",
  "src_manual": "Вручную",
  "src_auto": "Авто",
  "tier_legendary": "Легендарный",
  "tier_epic": "Эпический",
  "tier_rare": "Редкий",
  "tier_common": "Обычный",
  "verdict_tradeable": "Пригоден для торговли",
  "verdict_watch": "Наблюдать",
  "pressure_accumulation": "Накопление",
  "pressure_distribution": "Распределение",
  "reason_take_profit": "Тейк-профит",
  "reason_liquidation": "Ликвидация",
  "reason_stop_loss": "Стоп-лосс",
  "reason_trailing_take_profit": "Скользящий тейк-профит",
  "reason_trailing_stop": "Трейлинг-стоп",
  "reason_signal_flip": "Разворот сигнала",
  "welcome": "Добро пожаловать",
  "trader": "трейдер",
  "live": "В эфире",
  "verify_email_banner": "Подтвердите почту, чтобы открывать сделки. Ссылку для подтверждения ищите во входящих.",
  "resend": "Отправить снова",
  "verification_sent": "Письмо для подтверждения отправлено",
  "could_not_resend": "Не удалось отправить снова",
  "search_coin_placeholder": "Найдите любую монету (например, BTC, PEPE, ARB)",
  "add_to_watchlist": "Добавить в список наблюдения",
  "free_balance": "Свободный баланс",
  "in_positions": "В позициях",
  "total_equity": "Общий капитал",
  "watchlist": "Список наблюдения",
  "watchlist_empty": "Монет пока нет — найдите и нажмите +, чтобы добавить.",
  "high_exposure": "Используется {percent}% вашего свободного баланса — высокая экспозиция.",
  "advanced_tpsl": "Расширенные TP / SL",
  "entry_optional": "Вход (необязательно — по умолчанию по рынку)",
  "market": "рынок",
  "take_profit_price": "Цена тейк-профита",
  "stop_loss_price": "Цена стоп-лосса",
  "tp_example": "например, 72000",
  "sl_example": "например, 66000",
  "if_tp_hits": "Если сработает TP",
  "if_sl_hits": "Если сработает SL",
  "pnl_preview_note": "На основе маржи ${amount} × {leverage}x. Линии нарисованы на графике →",
  "clear_tpsl": "Очистить TP/SL",
  "one_tap_trade": "Торговля одним касанием",
  "tp_short": "TP",
  "sl_short": "SL",
  "auto_signals": "Авто-сигналы",
  "add_token_placeholder": "Добавьте любой токен (например, ARB, OP, TIA)",
  "analyze": "Анализировать",
  "analyzing_on": "Анализ {symbol} на {tf}…",
  "tap_to_load": "Нажмите, чтобы загрузить на график →",
  "scanning_market": "Сканирование рынка…",
  "no_signals": "Сигналов пока нет.",
  "money_depth": "Рыночная глубина денег",
  "sr_zones": "Зоны поддержки/сопротивления",
  "bot_analysis": "Анализ бота",
  "confidence": "Уверенность",
  "reasoning": "Обоснование",
  "tp_label": "Тейк-профит",
  "sl_label": "Стоп-лосс",
  "risk_reward": "Риск : Прибыль",
  "levels_from_position": "Актуальные уровни вашей открытой позиции",
  "levels_suggested": "Рекомендуемые уровни · не финансовая рекомендация",
  "toast_opened": "Открыта позиция {symbol} {leverage}x",
  "toast_closed": "Закрыта {symbol} · PnL ${pnl}",
  "toast_closed_pnl": "Закрыто · PnL ${pnl}",
  "ago_s": "{n} с назад",
  "ago_m": "{n} мин назад",
  "ago_h": "{n} ч назад",
  "ago_d": "{n} д назад",
  "in_label": "Приток",
  "out_label": "Отток",
  "confirm_reveal_email": "Показать почту этого пользователя? Почта конфиденциальна — смотрите только при необходимости.",
  "view_email_private": "Показать почту (конфиденциально)",
  "display_name_updated": "Отображаемое имя обновлено",
  "change_email_sent": "Ссылка для подтверждения отправлена на новую почту",
  "username_updated": "Имя пользователя обновлено",
  "password_changed": "Пароль изменён. Войдите снова на других устройствах.",
  "confirm_logout_all": "Выйти со всех устройств? Вам нужно будет войти снова.",
  "no_wallet": "Расширение кошелька не обнаружено (MetaMask/WalletConnect).",
  "wallet_rejected": "Подключение кошелька отклонено.",
  "profile_security": "Профиль и безопасность",
  "display_name": "Отображаемое имя",
  "display_name_optional": "Отображаемое имя (необязательно)",
  "edit": "Изменить",
  "cancel": "Отмена",
  "change": "Сменить",
  "in_days": "Через {days} д",
  "username_label": "Имя пользователя",
  "username_hint": "От 3 до 20 букв, цифр или нижних подчёркиваний. Можно менять раз в 30 дней.",
  "username_example": "например, arash_king",
  "email_private": "Почта (конфиденциально)",
  "change_email": "Сменить почту",
  "unverified": "Не подтверждена",
  "resend_verification": "Отправить подтверждение снова",
  "new_email": "Новая почта",
  "current_password": "Текущий пароль",
  "new_password": "Новый пароль",
  "confirm_new_password": "Подтвердите новый пароль",
  "send_verification_new": "Отправить подтверждение на новую почту",
  "change_email_hint": "Вы подтвердите смену по ссылке, отправленной на новую почту, а затем снова войдете в аккаунт.",
  "email_private_hint": "Ваша почта никогда не показывается публично. Только вы видите её здесь.",
  "sessions": "Сессии",
  "logout_all_devices": "Выйти со всех устройств",
  "change_password": "Сменить пароль",
  "pw_hint": "Минимум 8 символов, буква и цифра.",
  "update_password": "Обновить пароль",
  "coin_example_placeholder": "например, BTC, PEPE, TAO...",
  "username_or_email": "Имя пользователя или почта",
  "forgot_password_q": "Забыли пароль?",
  "invalid_email": "Введите корректный адрес почты",
  "pw_mismatch": "Пароли не совпадают",
  "username_hint_short": "От 3 до 20 букв, цифр или нижних подчёркиваний",
  "account_created_verify": "Аккаунт создан! Проверьте почту, чтобы подтвердить аккаунт.",
  "confirm_password_label": "Подтвердите пароль",
  "missing_verify_token": "Отсутствует токен подтверждения.",
  "email_verified_msg": "Почта подтверждена!",
  "verification_failed": "Не удалось подтвердить.",
  "verifying_email": "Подтверждаем вашу почту…",
  "email_verified_title": "Почта подтверждена",
  "go_to_login": "Перейти ко входу",
  "verification_failed_title": "Подтверждение не удалось",
  "verify_expired_hint": "Ссылка устарела? Войдите и воспользуйтесь «Отправить подтверждение снова» в настройках.",
  "back_to_login": "← Назад ко входу",
  "forgot_password": "Забыли пароль",
  "forgot_subtitle": "Введите имя пользователя или почту, и мы отправим ссылку для сброса.",
  "forgot_sent_toast": "Если аккаунт существует, ссылка для сброса отправлена.",
  "forgot_sent_full": "Если аккаунт существует, ссылка для сброса отправлена. Проверьте почту (действует 15 минут).",
  "send_reset_link": "Отправить ссылку для сброса",
  "remembered_it": "Вспомнили?",
  "missing_reset_token": "Отсутствует токен сброса. Используйте ссылку из письма.",
  "pw_requirement": "Пароль должен содержать минимум 8 символов, включая букву и цифру",
  "password_updated": "Пароль обновлён.",
  "reset_password": "Сброс пароля",
  "reset_subtitle": "Выберите новый пароль для вашего аккаунта.",
  "reset_invalid": "Ссылка для сброса недействительна или отсутствует. Запросите новую.",
  "request_reset_link": "Запросить ссылку для сброса",
  "new_password_label": "Новый пароль",
  "pw_hint2": "Минимум 8 символов, включая букву и цифру.",
  "update_password_btn": "Обновить пароль",
  "bullish": "Бычий",
  "bearish": "Медвежий",
  "inflow": "приток",
  "outflow": "отток",
  "volume_up": "Объём растёт",
  "volume_down": "Объём падает",
  "money_flow_mfi": "Денежный поток (MFI 14)",
  "flow_overbought": "Перекупленность",
  "flow_oversold": "Перепроданность",
  "flow_bullish": "Бычий приток",
  "flow_bearish": "Медвежий отток",
  "support": "Поддержка",
  "resistance": "Сопротивление",
  "available_for_trade": "Доступно для торговли",
  "free_balance_after": "Свободный баланс после",
  "tab_major": "Крупные",
  "tab_shitcoins": "Шиткоины",
  "tab_nfts": "NFT",
  "filter_direction": "Направление",
  "buy_only": "Только покупка",
  "sell_only": "Только продажа",
  "min_confidence": "Мин. уверенность",
  "confirm": "Подтвердить",
  "safety_score": "Оценка безопасности",
  "liquidity_lock": "Блокировка ликвидности",
  "locked": "Заблокирована",
  "unlocked": "Разблокирована",
  "honeypot": "Ханипот",
  "honeypot_safe_label": "Безопасно",
  "honeypot_risk": "Риск",
  "nft_demo_notice": "Демо-сделка — реальный NFT покупаться не будет",
  "view_on_opensea": "Открыть на OpenSea",
  "volume_24h": "Объём (24 ч)",
  "nft_position_opened": "Позиция NFT открыта (демо)",
  "crypto_positions_title": "Позиции по крипте и шиткоинам",
  "nft_positions_title": "Позиции NFT",
  "min_safety_required": "Для торговли оценка безопасности должна быть ≥ 75",
  "amount_exceeds_balance": "Сумма превышает ваш свободный баланс",
  "amount_gt_zero": "Сумма должна быть больше 0",
  "confirm_trade": "Подтвердить сделку",
  "usd_equiv": "≈",
  "nft_badge": "NFT",
  "no_nft_positions": "Нет открытых позиций NFT",
  "floor": "Флор",
  "rr_short": "П:Р",
  "best_marketplace": "Лучший рынок",
  "story": "История",
  "show_more": "Показать больше",
  "show_less": "Показать меньше",
  "view_chart": "Посмотреть график",
  "reason_sma_bull": "SMA9 выше SMA21 (бычий тренд)",
  "reason_sma_bear": "SMA9 ниже SMA21 (медвежий тренд)",
  "reason_rsi_oversold": "перепродано",
  "reason_rsi_overbought": "перекуплено",
  "reason_rsi_neutral": "нейтрально",
  "reason_pos_momentum": "Положительный импульс",
  "reason_neg_momentum": "Отрицательный импульс",
  "reason_insufficient": "Недостаточно данных",
  "reason_whale_accum": "Накопление китами",
  "reason_rising_floor": "Растущий флор",
  "reason_falling_floor": "Падающий флор",
  "reason_high_rarity": "Высокая редкость",
  "reason_mid_rarity": "Средняя редкость",
  "nft_trade_history": "История сделок с NFT",
  "no_nft_trades": "Закрытых сделок с NFT пока нет",
  "entry_floor": "Флор на входе",
  "exit_floor": "Флор на выходе",
  "verify_reminder": "Ваша почта ещё не подтверждена — подтвердите её, чтобы открыть торговлю.",
  "verify_now": "Подтвердить сейчас",
  "dismiss": "Закрыть",
  "trusted_devices": "Активные сессии · Устройства с входом в аккаунт",
  "font_size": "Размер шрифта",
  "font_small": "Малый",
  "font_medium": "Средний",
  "font_large": "Большой",
  "sessions_hint": "Телефоны и браузеры, с которых выполнен вход в ваш аккаунт (не API-ключи биржи).",
  "unknown_device": "Неизвестное устройство",
  "this_device": "Это устройство",
  "current_session": "Текущее",
  "last_active": "Последняя активность",
  "revoke_all_others": "Выйти со всех остальных устройств",
  "revoke_all_others_done": "Выход со всех остальных устройств выполнен",
  "no_other_devices": "Нет других активных устройств",
  "device_revoked": "Устройство выведено из аккаунта",
  "ui_logo_alt": "Логотип Firebird / Simorgh Trade",
  "ui_logo_switch_hint": "Нажмите, чтобы сменить логотип",
  "ui_vpn_info": "Информация о VPN"
};
export default ru;
